import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// A stop not yet published, which its pencil opens to finish and publish.
const UnpublishedTag = (props) => {
    return _jsx(_Fragment, { children: _jsx("div", { className: "tour-wizard__unpublished", children: _jsx("span", { className: "tour-wizard__tag", title: "This property is not published, so the tour page shows it as to be announced", children: "Unpublished" }) }) });
};
export default UnpublishedTag;
